// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-float-container {
  position: fixed;
  top: 100px;
  right: 48px;
  z-index: 1050;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding: 24px 0 24px 0;
  min-width: 180px;
  margin-right: 0px;
  width: 100%;
  max-width: 260px;
}

@media (max-width: 991.98px) {
  .progress-float-container {
    position: static;
    margin: 24px auto 0 auto;
    top: unset;
    right: unset;
    box-shadow: none;
    width: 100%;
    min-width: unset;
    z-index: auto;
  }
}
.progress-steps {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.progress-step {
  position: relative;
  margin-bottom: 8px;
}

button[mat-icon-button] {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid #ccc;
  background: #fff;
  opacity: 0.9;
  transform: scale(1);
}

button[mat-icon-button]:hover {
  opacity: 1;
  transform: scale(1.05);
}

button.active-step {
  border: 2px solid #ffeb3b;
  background: #ffeb3b;
  opacity: 1;
  transform: scale(1.05);
}

button.complete-step {
  border: 2px solid #8bc34a;
  background: #8bc34a;
  opacity: 1;
  transform: scale(1.05);
}

button.error-step {
  border: 2px solid #e57373;
  background: #e57373;
  opacity: 1;
  transform: scale(1.05);
}

button.upcoming-step {
  border: 2px dashed #ccc;
  background: #fff;
  opacity: 0.7;
  transform: scale(1);
}

.step-label {
  font-size: 1rem;
  color: #333;
  text-align: center;
  min-width: 120px;
}

.progress-connector {
  width: 2px;
  height: 32px;
  border-left: 2px dotted #bbb;
  margin: 0 auto;
}

.progress-float-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 220px;
  max-width: 260px;
  margin-left: 32px;
  position: relative;
  height: fit-content;
  z-index: 1;
}

@media (max-width: 991.98px) {
  .progress-float-wrapper {
    align-items: center;
    margin: 0 auto 24px auto;
    min-width: unset;
    max-width: unset;
    width: 100%;
    position: static;
    top: unset;
  }
}
@media (max-width: 767.98px) {
  .progress-float-wrapper {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/claims-app/claims-app-progress-step/claims-app-progress-step.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;EACE;IACE,gBAAA;IACA,wBAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,aAAA;EACF;AACF;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAEA;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AACF;;AACA;EACE,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AAAA;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,cAAA;AAGF;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAGF;;AAAA;EACE;IACE,mBAAA;IACA,wBAAA;IACA,gBAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,UAAA;EAGF;AACF;AAAA;EACE;IACE,wBAAA;EAEF;AACF","sourcesContent":[".progress-float-container {\r\n  position: fixed;\r\n  top: 100px;\r\n  right: 48px;\r\n  z-index: 1050;\r\n  background: transparent;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  padding: 24px 0 24px 0;\r\n  min-width: 180px;\r\n  margin-right: 0px;\r\n  width: 100%;\r\n  max-width: 260px;\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .progress-float-container {\r\n    position: static;\r\n    margin: 24px auto 0 auto;\r\n    top: unset;\r\n    right: unset;\r\n    box-shadow: none;\r\n    width: 100%;\r\n    min-width: unset;\r\n    z-index: auto;\r\n  }\r\n}\r\n\r\n.progress-steps {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.progress-step {\r\n  position: relative;\r\n  margin-bottom: 8px;\r\n}\r\n\r\nbutton[mat-icon-button] {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  border: 2px solid #ccc;\r\n  background: #fff;\r\n  opacity: 0.9;\r\n  transform: scale(1);\r\n}\r\n\r\nbutton[mat-icon-button]:hover {\r\n  opacity: 1;\r\n  transform: scale(1.05);\r\n}\r\n\r\nbutton.active-step {\r\n  border: 2px solid #ffeb3b;\r\n  background: #ffeb3b;\r\n  opacity: 1;\r\n  transform: scale(1.05);\r\n}\r\nbutton.complete-step {\r\n  border: 2px solid #8bc34a;\r\n  background: #8bc34a;\r\n  opacity: 1;\r\n  transform: scale(1.05);\r\n}\r\nbutton.error-step {\r\n  border: 2px solid #e57373;\r\n  background: #e57373;\r\n  opacity: 1;\r\n  transform: scale(1.05);\r\n}\r\nbutton.upcoming-step {\r\n  border: 2px dashed #ccc;\r\n  background: #fff;\r\n  opacity: 0.7;\r\n  transform: scale(1);\r\n}\r\n\r\n.step-label {\r\n  font-size: 1rem;\r\n  color: #333;\r\n  text-align: center;\r\n  min-width: 120px;\r\n}\r\n\r\n.progress-connector {\r\n  width: 2px;\r\n  height: 32px;\r\n  border-left: 2px dotted #bbb;\r\n  margin: 0 auto;\r\n}\r\n\r\n.progress-float-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  min-width: 220px;\r\n  max-width: 260px;\r\n  margin-left: 32px;\r\n  position: relative;\r\n  height: fit-content;\r\n  z-index: 1;\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .progress-float-wrapper {\r\n    align-items: center;\r\n    margin: 0 auto 24px auto;\r\n    min-width: unset;\r\n    max-width: unset;\r\n    width: 100%;\r\n    position: static;\r\n    top: unset;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .progress-float-wrapper {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
